import styled from 'styled-components';

export const HomeButtonContainer = styled.button`
  //position: absolute;
  top: 20px;
  left: 20px;
  padding: 8px 16px;
  background-color: #2B4B81;
  color: white;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.2s ease;
  z-index: 100;
  
  &:hover {
    background: #1a3366;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  }
  
  span {
    font-size: 14px;
    padding: 5px;
  }
`; 
